<app-card #card [cardTitle]="'EMPLOYEE_GROUP.TITLE' | translate"
    [useExternalButtons]="true"
    [showEdit]="isEditable"
    [disabled]="!settingsState.reviewPeriod.value">
    <div>
        <div>
            <div class="input-with-buttons padding-right-lg" *ngIf="groupList$ | async as groupList">
                <mat-form-field appearance="outline">
                    <mat-select [(value)]="groupState.value" disableOptionCentering class="drop-fix">
                        <mat-option *ngFor="let item of groupList" [value]="item">{{ item.name }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="rp-buttons">
                    <button mat-icon-button color="primary" (click)="addGroup();" *ngIf="card.actionState.editMode" title="{{ 'EMPLOYEE_GROUP.ADD_NEW_TEAM' | translate }}">
                        <mat-icon>add_circle_outline</mat-icon>
                    </button>
                </div>
            </div>

            <ng-container *ngIf="items$ | async as items">
                <div class="scroll-panel">
                    <app-dynamic-list-item (delete)="deleteMember(item)" [actionState]="card.actionState" [noEdit]="true" *ngFor="let item of items; index as i" [index]="i" [source]="item">
                        <div slot="readonly" class="flex-horizontal width-max read-only-area">
                            <div class="field-name">{{ item.itemSource.name + ' ' + (item.itemSource.employeeIdentifier ?? '') }}</div>
                        </div>
                    </app-dynamic-list-item>
                </div>
    
                <app-search *ngIf="card.actionState.editMode" placeholder="{{ 'EMPLOYEE_GROUP.ADD_NEW_MEMBER' | translate }}" (add)="addMember($event)" [inlineButtons]="true" [isAllowSearch]="true" [config]="searchMemberConfig" addButtonTooltip="{{ 'EMPLOYEE_GROUP.ADD_MEMBER' | translate }}"></app-search>
            </ng-container>

            <button mat-icon-button color="primary" *ngIf="card.actionState.editMode" (click)="addMembers()" title="{{ 'EMPLOYEE_GROUP.ADD_MEMBERS_BULK' | translate }}">
                <mat-icon>queue</mat-icon>
            </button>
        </div>        
    </div>
</app-card>
